/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
import styled from 'styled-components';
import { device } from '@/interfaces/constants';

export const Shelf = styled.div`
  display: block;
  z-index: 9;
  content: url('https://i.imgur.com/1QepZRl.png');
  position: relative;
  width: 100%;
  height: 175px;
  margin-left: auto;
  margin-right: auto;
`;

export const Box = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  position: relative;
  z-index: 10;
  margin-bottom: -80px; /* This is what actually puts the stuff ON the shelf instead of hovering above it */
  width: 80%;
  margin-left: auto;
  margin-right: auto;
`;

export const Banner = styled.img`
  @media ${device.mobileS} {
    width: 150px;
    height: 150px;
  }
  @media ${device.mobileM} {
    width: 150px;
    height: 150px;
  }
  @media ${device.mobileM} {
    width: 150px;
    height: 150px;
  }
  @media ${device.tablet} {
    width: 150px;
    height: 150px;
  }
  @media ${device.laptop} {
    width: 200px;
    height: 200px;
  }
  @media ${device.laptopL} {
    width: 200px;
    height: 200px;
  }
  @media ${device.desktop} {
    width: 200px;
    height: 200px;
  }
  @media ${device.desktopL} {
    width: 200px;
    height: 200px;
  }
  padding: 5px;
  object-fit: contain;
  cursor: pointer;
  &:hover {
    transform: scale(1.1, 1.2);
  }
`;
